import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { DigitalIdCardRequestModel } from '../models/interfaces/digital-id-card-request.model';

@Injectable({
    providedIn: 'root'
})
export class IdCardRequestsService {

    readonly DEFAULT_PAGE_SIZE = 15;
    readonly BASE_URL = '/benefits-api/benefits-admin/digital-id-card-request';

    constructor(
        private httpClient: HttpClient
    ) {}

    getIdCardRequests(sponsorId: number, page: number, sortBy: string, sortDir: string): Observable<any> {
        const headers = new HttpHeaders();
        const params = new HttpParams({
            fromObject: {
                page: page - 1,
                pageSize: this.DEFAULT_PAGE_SIZE,
                sortBy: sortBy,
                sortDir: sortDir
            }
        });
        return this.httpClient.get<any>(`${this.BASE_URL}/sponsor/${sponsorId}`, { headers, observe: 'response', params })
            .pipe(
                map((responseWithHeaders: any) => {
                    return {
                        count: parseInt(responseWithHeaders.headers.get('content-items'), 10),
                        totalPages: parseInt(responseWithHeaders.headers.get('total-pages'), 10),
                        currentPage: parseInt(responseWithHeaders.headers.get('current-page'), 10),
                        data: responseWithHeaders.body
                    };
                })
            );
    }

    closeIdCardRequest(cardRequestId: number) {
        return this.httpClient.patch(`${this.BASE_URL}/${cardRequestId}`, {});
    }

    requestNewDigitalIdCard(request: DigitalIdCardRequestModel): Observable<DigitalIdCardRequestModel> {
        return this.httpClient.post<DigitalIdCardRequestModel>(`${this.BASE_URL}`, request);
    }
}
